import { Spin } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { endpoint } from "@/api";
import appConfig from "@/config/appConfig";
import { userRole } from "@/constant";
import { flare } from "@flareapp/js";

const AlarmView = () => {
  const Params = useParams();
  const userDetails = useSelector((state) => state.user?.userDetails);
  const alarmId = Params.alarmId;
  const [alarmDetails, setAlarmDetails] = useState();
  const [isLoading, setLoading] = useState(false);

  const getNotification = async () => {
    setLoading(true);
    try {
      const response = await axios.get(endpoint.notification_v1 + "/" + alarmId, {
        withCredentials: true,
      });
      if (response) {
        setAlarmDetails(response.data);
      }
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log("get notification", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    getNotification();
    document.title = `${appConfig.name} - Alarm Details`;
  }, []);

  return (
    <div className="installer-view">
      <div className="card p-3 m-md-3">
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <label className="az-content-label">Manage Alarm</label>
            <span className="d-block py-2">Alarm Profile</span>
          </div>
        </div>
        <hr className="mt-0" />
        {/* <h3>Alarm Profile</h3> */}
        <Spin spinning={isLoading}>
          <div className="row mt-4">
            <div className="col-md-6">
              <div className="row mb-2">
                <div className="col-5">Alarm Name</div>
                <div className="col-7">: {alarmDetails?.name}</div>
              </div>
              <div className="row mb-2">
                <div className="col-5">Alarm Type</div>
                <div className="col-7 text-capitalize">: {alarmType[alarmDetails?.type]}</div>
              </div>
              <div className="row mb-2">
                <div className="col-5">Site Location</div>
                <div className="col-7">
                  {" "}
                  <div className="d-flex">
                    <span>: </span>
                    <div className="d-inline-block">
                      {alarmDetails?.site?.map((item, ind) => (
                        <p key={ind} className="mb-0 ms-1">
                          {item.name}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-5">Device</div>
                <div className="col-7">
                  <div className="d-flex">
                    <span>: </span>
                    <div className="d-inline-block">
                      {alarmDetails?.device?.map((item, ind) => (
                        <p key={ind} className="mb-0 ms-1">
                          {item.name}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-5">Device Parameter</div>
                <div className="col-7">
                  <div className="d-flex">
                    <span>: </span>
                    <div className="d-inline-block">
                      {alarmDetails?.parameter?.map((item, ind) => (
                        <p className="mb-0 ms-1" key={ind}>
                          {/* {item?.device?.name} {">"}  */}
                          {item.name}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-5">Alarm Notification Option</div>
                <div className="col-7 text-capitalize">: {alarmDetails?.option}</div>
              </div>
              <div className="row mb-2">
                <div className="col-5 text-capitalize">{alarmDetails?.option} value</div>
                <div className="col-7">
                  :{" "}
                  {alarmDetails?.option === "max"
                    ? alarmDetails?.max
                    : alarmDetails?.option === "min"
                      ? alarmDetails?.min
                      : `${alarmDetails?.min} to ${alarmDetails?.max}`}
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-5">Trigger Interval</div>
                <div className="col-7">: {alarmDetails?.interval}</div>
              </div>
            </div>
            <div className="col-md-6"></div>
          </div>
          <div className="row">
            <div className="col-md-12 d-flex justify-content-end">
              {userDetails?.role !== userRole.public && (
                <Link to={`/edit-alarm/` + alarmId} className="btn btn-success me-1">
                  Edit
                </Link>
              )}
              <Link to={`/alarm-summary`} className="btn btn-secondary">
                Back
              </Link>
            </div>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default AlarmView;

const alarmType = {
  email: "Email + System Notification",
  message: "Email + SMS + System Notification",
};
